export const enClientPortalCreateOrderPagePages = {
    orders: {
        createOrderPage: {
            title: 'Create new order',
            infoTitle: 'Note',
            missingPermission:
                'You do not have permission to create a new order through the einwert platform. Please send a request instead to',
            futureAccess:
                'If you would like to create orders through the einwert platform in the future, we can enable the feature for you on request.',
            successMessage: 'Thank you for your order.',
            successAction: 'To overview',
            error: {
                failed: 'The order data could not be submitted',
                retry: 'please try again.',
                contact: 'If the error persists, please contact us:',
                phone: 'Phone: +49 89 1795 93801',
                email: 'Email: auftrag@einwert.com',
            },
            steps: {
                asset: 'Create asset',
                valuation: 'Order appraisal',
            },
            footer: {
                back: 'Back',
                next: 'Next',
                cancel: 'Cancel',
                submit: 'Order now',
            },
            validation: {
                requiredField: 'Required field',
            },
            mandator: {
                additionalMandatorsTitle: 'Additional mandators',
                additionalMandatorsDisabledTooltip: 'Please select a primary mandator above before adding additional mandators.',
                addAdditionalMandatorAriaLabel: 'Add additional mandators',
                additionalMandatorsQuestion: 'Are there additional mandators that should be listed in the appraisal?',
                mandatorSelect: {
                    inputLabel: 'Select mandator',
                    addNew: 'Add new mandator',
                    addModalTitle: 'Add mandator',
                    requiredField: 'Required field',
                },
                mandatorListItem: {
                    edit: 'Edit',
                    delete: 'Delete',
                    editModalTitle: 'Edit mandator',
                },
                mandatorForm: {
                    name: 'Name',
                    street: 'Street',
                    houseNumber: 'House number',
                    zip: 'Postal code',
                    city: 'City',
                    country: 'Country',
                },
                contactForm: {
                    salutation: 'Salutation',
                    salutationOptions: {
                        mr: 'Mr.',
                        ms: 'Ms.',
                        dr: 'Dr.',
                        mrDr: 'Mr. Dr.',
                        msDr: 'Ms. Dr.',
                        placeholder: 'Select salutation',
                    },
                    name: 'First and last name',
                    role: 'Role',
                    company: 'Company',
                    street: 'Street',
                    houseNumber: 'House number',
                    zip: 'Postal code',
                    city: 'City',
                    email: 'Email',
                    invalidEmail: 'Invalid email',
                    phoneNumber: 'Phone number',
                    invalidPhoneNumber: 'Invalid phone number',
                    note: 'Note / when should this person be contacted?',
                    infoBox: 'All fields are optional. Please only provide personal information needed for contact.',
                },
                contactListItem: {
                    edit: 'Edit',
                    delete: 'Delete',
                    editModalTitle: 'Edit contact',
                },
                additionalContactsTitle: 'Additional contacts',
                additionalContactsDescription:
                    'Do you have additional contact details for people involved in the appraisal or asset? Owner details, for example, can help coordinate an inspection appointment.',
                addContactTitle: 'Add contact',
                addContactAriaLabel: 'Add additional contacts',
                discardUnsavedChanges: 'You have unsaved changes. Do you really want to discard the changes and continue?',
            },
            asset: {
                createNew: 'Create new asset',
                linkExisting: 'Link existing asset',
                search: 'Search asset',
                noMatchingAssets: 'No matching assets found',
                noAssetSelected: 'Please create or select an asset first',
                customerAssetReference: 'Customer-internal asset ID',
                customerAssetReferenceTooltip:
                    'Optionally, you can store your company-internal asset ID for the new asset. This lets you search and filter for specific assets more quickly on overview pages later.',
                addressSearch: {
                    noMatchingAddress: 'No matching address found',
                    enterAddressToShowOptions: 'Enter an address to show options',
                    consentRequiredLabel: 'To use address search, please allow Google Maps',
                    searchLabel: 'Search address',
                },
                address: {
                    defaultCountry: 'Germany',
                    street: 'Street',
                    houseNumber: 'House number',
                    state: 'State',
                    city: 'City',
                    zip: 'Postal code',
                    country: 'Country',
                },
            },
            valuation: {
                valuationDate: 'Valuation date',
                valuationReason: 'Order purpose *',
                assetUsageTypes: 'Usage type / asset type',
                assetUsageTypesTooltip:
                    'Please specify the usage or asset type of all assets that are part of this valuation. You can select multiple options. If the matching asset type is not listed, you can also enter free text.',
                additionalInformation: 'Additional information',
                assignees: 'Assignees',
                additionalContacts: 'Additional contacts',
                objectId: 'Asset ID:',
                costCenter: {
                    inputLabel: 'Select cost center',
                    addNewLabel: 'Add new cost center',
                    form: {
                        name: 'Cost center name',
                        description: 'Short description',
                    },
                },
                customerAssignment: {
                    addButton: 'Add customer',
                    modalTitle: 'Assigned customers',
                    cancel: 'Cancel',
                    duplicateWarning: 'The same customer was selected more than once. Please change one of the entries.',
                    assigneeLabel: 'Assigned customer',
                    removeTooltip: 'Remove',
                    addMore: 'Add another',
                },
                contactForm: {
                    salutation: 'Salutation',
                    salutationOptions: {
                        mr: 'Mr.',
                        ms: 'Ms.',
                        dr: 'Dr.',
                        mrDr: 'Mr. Dr.',
                        msDr: 'Ms. Dr.',
                        placeholder: 'Select salutation',
                    },
                    name: 'First and last name',
                    role: 'Role',
                    company: 'Company',
                    street: 'Street',
                    houseNumber: 'House number',
                    zip: 'Postal code',
                    city: 'City',
                    email: 'Email',
                    invalidEmail: 'Invalid email',
                    phoneNumber: 'Phone number',
                    invalidPhoneNumber: 'Invalid phone number',
                    note: 'Note / when should this person be contacted?',
                    infoBox: 'All fields are optional. Please only provide personal information needed for contact.',
                },
                contactListItem: {
                    edit: 'Edit',
                    delete: 'Delete',
                    editModalTitle: 'Edit contact',
                },
            },
        },
    },
}
